import http from "../../utils/http";
import { toast } from "../../utils/toast";
// 사업장조회
export const getPlaces = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/places/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사업장 등록하기
export const createPlaces = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/places", body)
      .then((res) => {
        toast.success('사업장 등록이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사업장 일괄삭제
export const deletePlaces = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete("/places", body)
      .then((res) => {
        toast.success('사업장 일괄 삭제 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사업장 수정
export const putPlaces = (placeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/places/${placeIdx}`, body)
      .then((res) => {
        toast.success('사업장 수정이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사업장 일괄 등록하기
export const createPlacesMultiple = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/places/multiple`, body)
      .then((res) => {
        toast.success('사업장 일괄 등록이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 사업장 엑셀 다운로드
export const getPlacesExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/places/excel`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 엑셀 업로드 샘플파일 다운로드
export const getPlacesExcelSample = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/places/excel/sample")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
